import(/* webpackMode: "eager", webpackExports: ["LoyaltyDetailsClient"] */ "/app/src/app/(pages)/(static)/(rewards)/loyalty-details/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/cookies/client.ts");
